import React, { useState, useEffect } from 'react'

import ContractCardBaseInfo from './ContractCardTab/ContractCardBaseInfo'
import ContractCardSupplierInfo from './ContractCardTab/ContractCardSupplierInfo'
import ContractCardContractInfo from './ContractCardTab/ContractCardContractInfo'
import ContractCardAnnotation from './ContractCardTab/ContractCardAnnotation'
import ContractCardPurchaseInfo from './ContractCardTab/ContractCardPurchaseInfo'
import ContractCardUserInfo from './ContractCardTab/ContractCardUserInfo'

import PieChartPerformanceDoc from './../components/DashboardCharts/PieChartPerformanceDoc'
import PieChartPerformancePayment from './../components/DashboardCharts/PieChartPerformancePayment'
import PieChartPerformanceDate from './../components/DashboardCharts/PieChartPerformanceDate'

import { Structure } from '../../../Org/Structure/types'
import { Contract } from '../../../Contracts/types'
import { PerformanceChart } from '../types'

type Props = {
    theme: string
    contract: Contract
    contractGuid: string
    structShortName: string | null
    structShortGuid: string | null
    onStructChange: (value: {
        structName: string | null
        structGuid: string | null
    }) => void
    typeObjectContract: string | null
    onTypeObjectContractChange: (value: string | null) => void
    annotationContract: string | null
    onAnnotationContractChange: (value: string | null) => void
    structList: Structure[]
    performanceChart: PerformanceChart | null
    contractSum: number
    isUserRoleName: string
    onSupervisorChange: (
        guid: string,
        f_name: string,
        l_name: string,
        p_name: string
    ) => void
}

const ContractCardTab: React.FC<Props> = (props) => {
    return (
        <div className="flex flex-col w-full gap-5">
            <div className="flex flex-row w-full gap-5">
                <div className="flex flex-col w-full h-60 bg-[#FFFFFF] dark:bg-[#262427] rounded-lg p-3 shadow-lg shadow-[#18181825]">
                    {props.performanceChart ? (
                        <PieChartPerformanceDate
                            contractRegNumber={
                                props.contract.contract_reg_number
                            }
                            contractStartDate={
                                props.contract.start_execution_date ||
                                'Нет данных'
                            }
                            contractEndDate={
                                props.contract.end_execution_date ||
                                'Нет данных'
                            }
                            initialIndex={1}
                            totalIndex={0}
                            theme={props.theme}
                        />
                    ) : (
                        <div className="flex flex-row text-[#181818] dark:text-[#FFFFFF] text-[16px] w-full h-full items-center justify-center gap-2">
                            <svg
                                className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                ></circle>
                                <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                ></path>
                            </svg>
                            <span>Загрузка</span>
                        </div>
                    )}
                </div>
                <div className="flex flex-col w-full h-60 bg-[#FFFFFF] dark:bg-[#262427] rounded-lg p-3 shadow-lg shadow-[#18181825]">
                    {props.performanceChart ? (
                        <PieChartPerformanceDoc
                            contractSum={props.contractSum}
                            performanceChart={
                                props.performanceChart || 'Нет данных'
                            }
                            initialIndex={1}
                            totalIndex={0}
                            theme={props.theme}
                        />
                    ) : (
                        <div className="flex flex-row text-[#181818] dark:text-[#FFFFFF] text-[16px] w-full h-full items-center justify-center gap-2">
                            <svg
                                className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                ></circle>
                                <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                ></path>
                            </svg>
                            <span>Загрузка</span>
                        </div>
                    )}
                </div>
                <div className="flex flex-col w-full h-60 bg-[#FFFFFF] dark:bg-[#262427] rounded-lg p-3 shadow-lg shadow-[#18181825]">
                    {props.performanceChart ? (
                        <PieChartPerformancePayment
                            contractSum={props.contractSum}
                            performanceChart={
                                props.performanceChart || 'Нет данных'
                            }
                            initialIndex={1}
                            totalIndex={0}
                            theme={props.theme}
                        />
                    ) : (
                        <div className="flex flex-row text-[#181818] dark:text-[#FFFFFF] text-[16px] w-full h-full items-center justify-center gap-2">
                            <svg
                                className="animate-spin h-4 w-4 text-[#181818] dark:text-[#FFFFFF]"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                ></circle>
                                <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                ></path>
                            </svg>
                            <span>Загрузка</span>
                        </div>
                    )}
                </div>
            </div>
            <div className="flex flex-row w-full gap-5">
                <div className="flex flex-col w-full gap-5">
                    <ContractCardBaseInfo
                        theme={props.theme}
                        contractGuid={props.contractGuid}
                        structShortName={props.structShortName}
                        structShortGuid={props.structShortGuid}
                        onStructChange={props.onStructChange}
                        typeObjectContract={props.typeObjectContract}
                        onTypeObjectContractChange={
                            props.onTypeObjectContractChange
                        }
                        structList={props.structList}
                    />
                    <ContractCardContractInfo
                        theme={props.theme}
                        contract={props.contract}
                        contractGuid={props.contractGuid}
                        structShortName={props.structShortName}
                        structShortGuid={props.structShortGuid}
                        structList={props.structList}
                    />
                    <ContractCardPurchaseInfo
                        theme={props.theme}
                        contract={props.contract}
                        contractGuid={props.contractGuid}
                        structShortName={props.structShortName}
                        structShortGuid={props.structShortGuid}
                        structList={props.structList}
                    />
                </div>
                <div className="flex flex-col w-full gap-5">
                    <ContractCardUserInfo
                        theme={props.theme}
                        contract={props.contract}
                        contractGuid={props.contractGuid}
                        structShortName={props.structShortName}
                        structShortGuid={props.structShortGuid}
                        structList={props.structList}
                        isUserRoleName={props.isUserRoleName}
                        onSupervisorChange={props.onSupervisorChange}
                    />
                    <ContractCardSupplierInfo
                        theme={props.theme}
                        contract={props.contract}
                        contractGuid={props.contractGuid}
                        structShortName={props.structShortName}
                        structShortGuid={props.structShortGuid}
                        structList={props.structList}
                    />
                    <ContractCardAnnotation
                        theme={props.theme}
                        contractGuid={props.contractGuid}
                        structShortName={props.structShortName}
                        structShortGuid={props.structShortGuid}
                        annotationContract={props.annotationContract}
                        onAnnotationContractChange={
                            props.onAnnotationContractChange
                        }
                    />
                </div>
            </div>
        </div>
    )
}

export default ContractCardTab
